<footer class="border-t border-line bg-surface mt-8">
 <div class="px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted">
 <div>© {{ year }} Nozom Plus. All rights reserved.</div>
 <div class="flex items-center gap-4">
 <a href="/legal/privacy" class="hover:text-ink transition">{{ 'FOOTER.privacy' | translate }}</a>
 <a href="/legal/terms" class="hover:text-ink transition">{{ 'FOOTER.terms' | translate }}</a>
 <a href="/legal/withdrawal-refund" class="hover:text-ink transition">{{ 'FOOTER.withdrawal' | translate }}</a>
 <a href="#" class="hover:text-ink transition">Support</a>
 </div>
 </div>
</footer>
